import React from 'react';
import { Trans } from '@lingui/macro';

// eslint-disable-next-line no-unused-vars
const PARTNERS = [
  { 
    name: 'Black Ice Events', 
    description: <Trans>Event Planner</Trans>,
    website: 'https://www.blackiceevents.com',
    image: 'images/sponsors/black-ice-events.png'
  },
  { 
    name: 'Groupe Eventify', 
    description: <Trans>Event Planner</Trans>,
    website: 'https://instagram.com/groupe_eventify',
    image: 'images/sponsors/groupe-eventify.png'
  },
  { 
    name: 'BASSement', 
    description: <Trans>Event Planner</Trans>,
    website: 'https://instagram.com/bassement_qc',
    image: 'images/sponsors/bassement.png'
  },
  { 
    name: 'Off Limits', 
    description: <Trans>Event Planner</Trans>,
    website: 'https://offlimitsprojekt.com',
    image: 'images/sponsors/off-limits.png'
  },
];

const SPONSORS = [
  { 
    name: 'Aneyro', 
    description: <Trans>Hotel management company in Old Quebec</Trans>,
    website: 'https://aneyrohotels.com',
    image: 'images/sponsors/aneyro.png'
  },
  { 
    name: 'Jackalhop', 
    description: <Trans>Microbrewery in the Centre-du-Québec region</Trans>,
    website: 'https://jackalhop.com',
    image: 'images/sponsors/jackalhop.png'
  },
  { 
    name: 'IGA Extra Plessisville', 
    description: <Trans>Grocery store in the Centre-du-Québec region</Trans>,
    website: 'https://www.iga.ca',
    image: 'images/sponsors/iga.png'
  },
];

function Sponsors() {
  const logoStyle = {
    height: '100px',
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
    margin: '0 auto',
    display: 'block'
  };

  return (
    <section className="section py-5" id="sponsors">
      <div className="bg-overlay bg-gradient-tertiary" style={{ opacity: 0.85 }}></div>
      <div className="about-particles">
        {[...Array(15)].map((_, i) => (
          <div key={i} className="particle" style={{ '--delay': `${Math.random() * 10}s`, '--x': `${Math.random() * 100}%`, '--duration': `${10 + Math.random() * 10}s` }}></div>
        ))}
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <h4 className="title text-white mb-4"><Trans>OUR PARTNERS</Trans></h4>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {PARTNERS.map((partner, index) => (
            <div className="col-lg-3 col-md-6 mb-4" key={index}>
              <div className="ticket-modern-card">
                <div className="ticket-card-glow"></div>
                <div className="ticket-card-content">
                  <div className="ticket-card-gradient">
                    <div className="mb-4">
                      <img 
                        src={partner.image} 
                        alt={partner.name} 
                        style={logoStyle}
                        className="img-fluid"
                      />
                    </div>
                    <h5 className="ticket-name mb-2">{partner.name}</h5>
                    <p className="para-desc text-white mb-3" style={{ opacity: 0.7 }}>
                      {partner.description}
                    </p>
                  </div>
                  {partner.website && (
                    <a 
                      href={partner.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="home-btn mt-auto"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <Trans>Visit Website</Trans>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>





        <div className="row justify-content-center mt-5">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <h4 className="title text-white mb-4"><Trans>OUR SPONSORS</Trans></h4>
              <p className="para-desc mx-auto text-white mb-2">
                <Trans>We're grateful to our sponsors who make this event possible!</Trans>
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {SPONSORS.map((sponsor, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="ticket-modern-card">
                <div className="ticket-card-glow"></div>
                <div className="ticket-card-content">
                  <div className="ticket-card-gradient">
                    <div className="mb-4">
                      <img 
                        src={sponsor.image} 
                        alt={sponsor.name} 
                        style={logoStyle}
                        className="img-fluid"
                      />
                    </div>
                    <h5 className="ticket-name mb-2">{sponsor.name}</h5>
                    <p className="para-desc text-white mb-3" style={{ opacity: 0.7 }}>
                      {sponsor.description}
                    </p>
                  </div>
                  {sponsor.website && (
                    <a 
                      href={sponsor.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="home-btn mt-auto"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <Trans>Visit Website</Trans>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Sponsors;